export const noteReducer = (state = '', action) => {
  switch (action.type) {
    case 'NOTE':
      return action.note
    default:
      return state
  }
}
